export interface PaasResult {
  resumeHash: string
  url: string
}

export interface PaasError {
  message: string
  fieldName: string
}

export interface PaasResponse {
  result: PaasResult
  errors: PaasError[]
  status: number
}

export enum PrefillEnvironment {
  Local = 'http://localhost:8010/v1/prefill',
  Shared = 'https://paas.finanzcheck-shared.de/v1/prefill',
  Stage = 'https://paas.finanzcheck-stage.de/v1/prefill',
  Production = 'https://paas.finanzcheck.de/v1/prefill',
}

const prefillHeaders = {
  'Content-Type': 'application/json',
}

export async function prefill<T = unknown>(
  environment: PrefillEnvironment,
  payload: T,
): Promise<PaasResponse> {
  const response = await fetch(environment, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: prefillHeaders,
  })

  return response.json()
}
